import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import { add, endOfDay, startOfDay } from 'date-fns';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AbilityContext } from '../../components/ability/can';
import { useCompanies } from '../../components/selectors/GlobalCompanySelector/CompanyContext';
import { useDocumentTitle } from '../../components/useDocumentTitle';
import { usePageLocation } from '../usePageState';
import { ImpactInformation } from './components/ImpactInformation/ImpactInformation';
import { WeatherForecast } from './components/WeatherForecast/WeatherForecast';
import { useAuth } from '../../domain/auth/useAuth';
import { SitesMapWidget } from './SitesMapWidget';
import { EventsDateWidget } from './components/EventsDateWidget/EventsDateWidget';
import './Dashboard.css';

export const DATE = {
    today: {
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
    },
    tomorrow: {
        start: startOfDay(add(new Date(), { days: 1 })),
        end: endOfDay(add(new Date(), { days: 1 })),
    },
};

export function Dashboard() {
    useDocumentTitle('Dashboard');
    const { companyId } = useCompanies()!;
    const auth = useAuth();
    const ability = useContext(AbilityContext);
    const urlLocation = useLocation();
    const { queryToState } = usePageLocation();
    const pageState: any = queryToState(urlLocation.search);

    const [activeEventMarketsMap, setActiveEventMarketsMap] = useState(new Map<string, string[]>());

    const onActiveEventsHandle = (field: string) => (value: string[]) => {
        setActiveEventMarketsMap(prev => {
            const newMap = new Map(prev);
            newMap.set(field, value);
            return newMap;
        });
    };

    useEffect(() => {
        setActiveEventMarketsMap(new Map<string, string[]>());
    }, [companyId]);

    return (
        <Row key="" className="dashboard-page" gutter={[16, 16]} data-cy="dashboard-page">
            <Col xs={24} md={12} key="weather-forecast">
                <div style={{ marginBottom: '16px', padding: 0 }}>
                    <Row gutter={[14, 16]}>
                        <Col xs={24} md={12}>
                            <EventsDateWidget
                                title="Today's Events"
                                date={DATE.today}
                                company={companyId}
                                onActiveEventsHandle={onActiveEventsHandle('today')}
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <EventsDateWidget
                                title="Tomorrow's Events"
                                date={DATE.tomorrow}
                                company={companyId}
                                onActiveEventsHandle={onActiveEventsHandle('tomorrow')}
                            />
                        </Col>
                    </Row>
                </div>
                <WeatherForecast location={pageState.location} activeEventMarketsMap={activeEventMarketsMap} />
            </Col>

            <Col xs={24} md={12} key="sites-map">
                {ability.can('read', 'ImpactReporting') &&
                    (auth?.user?.isUtilityCustomer() ? (
                        !companyId && <ImpactInformation company={auth?.user?.company_id} />
                    ) : (
                        <ImpactInformation company={companyId} />
                    ))}

                <SitesMapWidget />
            </Col>
        </Row>
    );
}
